import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './HeaderButton.css';

export interface IHeaderButtonProps {
  type: 'l' | 'xs';
  onClick: () => void;
  dataTestId?: string;
}

export const HeaderButton = ({ type, onClick, children, dataTestId }: React.PropsWithChildren<IHeaderButtonProps>) => {
  const handleClick = React.useCallback(
    (e: React.SyntheticEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onClick();
    },
    [onClick],
  );

  return (
    <button
      type="button"
      onClick={handleClick}
      className={clsx(style['container'], style[`container--${type}`])}
      data-testid={dataTestId}
    >
      {children}
    </button>
  );
};
